import { BaseService } from '@flint/framework';

export default class SubscriptionList extends BaseService {
  constructor() {
    super("FETCHING_SUBSCRIPTION_LIST", 'SubscriptionListStore', true);
  }

  handleEvent(eventName) {
    return this.getClient('vetService').get(`/admin-api/subscriptions/plans`);
  }
}